import { ISkill } from '@/contracts/SkillContract';
import { DataSource } from './abstract-data-source';
import { AbstractDataSourceType } from './abstract-data-source-type';


interface IdToSkill {
    [key: string]: SkillDataType;
}

export declare interface SkillDataType extends AbstractDataSourceType, ISkill { }

export class SkillsDataSource extends DataSource {
    public data: SkillDataType[];
    public skillIdToSkill: IdToSkill;

    constructor(skills: ISkill[]) {
        super(skills);

        this.skillIdToSkill = {};
        this.data.forEach((s) => {
            this.skillIdToSkill[s.Id] = s;
        });
    }
}
